import { NgModule } from 'ng-metadata/core';
import {PnxUtil} from './pnxUtil.service';
import {EndlessScrollingUtil} from './endlessScollingUtil.service';
import {SmoothScrollUtil} from './smoothScrollUtil.service';
import {ConfigurationUtil} from './configurationUtil.service';
import {TemplateUtil} from './templateUtil.service';
import {JsonUtils} from './jsonUtils.service';
import {UUIDGenerator} from './UUIDGenerator.service';
import {SearchUtil} from './searchUtil.service';
import {ResultUtil} from './resultUtil.service';
import {DateUtils} from './dateUtils.service';
import {StringUtils} from './stringUtils.service';
import {ArrayUtils} from './arrayUtils.service';
import {FilterInstitution} from './filterInstitution.service';
import {FilterLanguage} from './filterLanguage.service';
import { PartiallyTranslatedFieldsUtil } from './partiallyTranslatedFieldsUtil.service';
import { AlmaOtherMembersService } from '../search/fullView/getit/almaOtherMembers/almaOtherMembers.service';
import {WindowInfoUtils} from './windowInfoUtils.service';
import {CslUtils} from './cslUtils.service';
import {AnalyticsUtils} from './analyticsUtils.service';

@NgModule({
    declarations: [
    ],
    providers: [
        ArrayUtils,
        ConfigurationUtil,
        DateUtils,
        EndlessScrollingUtil,
        JsonUtils,
        PnxUtil,
        ResultUtil,
        SearchUtil,
        SmoothScrollUtil,
        StringUtils,
        TemplateUtil,
        UUIDGenerator,
        FilterInstitution,
        FilterLanguage,
        PartiallyTranslatedFieldsUtil,
        AlmaOtherMembersService,
        WindowInfoUtils,
		CslUtils,
        AnalyticsUtils
    ],
    imports:[
    ]
})

export class NddModule{}



// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/ndd.module.ts